import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { ApiError, Pipeline } from 'utils/types';

import c from '../utils/constants';
import { pipelineTransformer } from '../transformer';

export default function useGetPipeline(id?: string) {
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useQuery<Pipeline, ApiError>({
    queryKey: [c.PIPELINES, id],
    queryFn: async () => {
      const api = new Api(args);

      const data: { data: Pipeline; meta: any } = await api.get(
        await withAcl({
          account: {
            url: `api/v1/sales/pipelines/${id}`,
            transformer: pipelineTransformer.pipeline,
            params: { include: ['deal', 'stage'] },
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/sales/pipelines/${id}`,
            transformer: pipelineTransformer.pipeline,
            params: { include: ['deal', 'stage'] },
          },
        }),
      );

      return data?.data;
    },
    enabled: !!id,
  });
}
